import { User } from '../../models/User';

export const getUserInitials = (user: User): string => {
  return `${user.firstname && user.firstname[0]} ${
    user.lastname && user.lastname[0]
  }`;
};
